import { cn } from "src/lib/utils";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { cva } from "class-variance-authority";
import { Fragment } from "react";

export const dropdownActionVariants = cva("tw-w-full tw-py-2.5 tw-px-2 tw-h-auto tw-text-left tw-gap-2 tw-font-medium *:tw-rounded-[5px]", {
	variants: {
		variant: {
			default: "tw-text-popover-foreground hover:tw-bg-slate-100 hover:tw-text-primary",
			destructive: "!tw-bg-red-100 !tw-text-red-600 hover:!tw-bg-red-200",
		},
	},
	defaultVariants: {
		variant: "default",
	},
});

const CustomDropdown = ({ trigger, actions, align, side = "bottom", className = "", open, triggerClassName, onOpenChange }) => {
	return (
		<Popover open={open} onOpenChange={onOpenChange}>
			<PopoverTrigger className={triggerClassName} asChild>
				{trigger}
			</PopoverTrigger>
			<PopoverContent align={align} side={side} className={cn("!tw-p-2 tw-w-[200px]", className)}>
				<div className="tw-flex tw-flex-col tw-gap-1 [&>span]:tw-text-[0.9rem] [&>span]:tw-px-2 [&>span]:tw-py-2.5 [&>span]:tw-rounded-[5px] hover:[&>span]:tw-bg-slate-100 hover:[&>span]:tw-text-primary [&>span]:tw-cursor-pointer">
					{actions.map(({ onClick = () => {}, label, disabled, asChild, variant = "default" }, index) =>
						asChild ? (
							<Fragment key={`popover-action-${index}`}>{label}</Fragment>
						) : (
							<button
								key={`popover-action-${index}`}
								className={dropdownActionVariants({ variant })}
								onClick={onClick}
								disabled={disabled}
							>
								{label}
							</button>
						)
					)}
				</div>
			</PopoverContent>
		</Popover>
	);
};

export default CustomDropdown;
